export default "__VITE_ASSET__DWcxj38a__"